// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* TODO: Find a better way to set the cursor for all contents of dialog. */\n.DraggableItem.draggable div {\n  cursor: -webkit-grab !important;\n  cursor: grab !important;\n}\n.DraggableItem.draggable.dragging div {\n  cursor: -webkit-grabbing !important;\n  cursor: grabbing !important;\n}\n", ""]);
// Exports
module.exports = exports;
